import {
  Breadcrumb,
  Calendar,
  Callout,
  Checkbox,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  Dropdown,
  DropdownMenuItemType,
  FocusTrapZone,
  IBasePickerSuggestionsProps,
  IDropdownOption,
  IPersonaProps,
  ISelectableOption,
  NormalPeoplePicker,
  PrimaryButton,
  Stack,
  Text,
  TextField,
} from "office-ui-fabric-react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  getAllCustomers,
  getCustomers,
  getUpTimeDetails,
  updateUpTime,
} from "../../../services/customers/CustomerService";
import { getAllDataCentersOfCustomer } from "../../../services/datacenter/DatacenterService";
import {
  ICustomers,
  IDataCenter,
  IFloorVM,
  ISearchUpTime,
  IUpTime,
} from "../../../vm";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { API_URL, childrenGap, DayPickerStrings } from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import moment from "moment";
import { Formik } from "formik";
import { getToken, parseJwt } from "../../../services/UtilService";
import ManageImportDialog from "./ManageImportDialog";
import { Loading } from "../../../services/Loading";

export interface UpTimeMainProps { }

let calendarButtonElement: HTMLElement;

// const DayPickerString = {
//   months: [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ],
//   shortMonths: [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ],
//   days: [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ],
//   shortDays: ["S", "M", "T", "W", "T", "F", "S"],
//   goToToday: "Go to today",
//   weekNumberFormatString: "Week number {0}",
//   prevMonthAriaLabel: "Previous month",
//   nextMonthAriaLabel: "Next month",
//   prevYearAriaLabel: "Previous year",
//   nextYearAriaLabel: "Next year",
//   prevYearRangeAriaLabel: "Previous year range",
//   nextYearRangeAriaLabel: "Next year range",
//   closeButtonAriaLabel: "Close",
//   monthPickerHeaderAriaLabel: "{0}, select to change the year",
//   yearPickerHeaderAriaLabel: "{0}, select to change the month",
// };

const UpTimeMain: React.FC<UpTimeMainProps> = () => {
  //custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const tokenData = parseJwt();

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isEdit: false,
    customer: {
      name: "",
      regSapNo: "",
    },
    date: new Date(),
    showCallender: false,
    searchObj: {
      customerId: params.customerId,
      startDate: new Date(),
      endDate: new Date(),
      datacenterId: undefined,
      floorId: undefined,
    },
    dataCenterOptions: [],
    allFloorsDropdownList: [
      // { key: 'all', text: 'All' }
    ],
    dataCenters: [],
    upTimeList: [],
    datesList: [],
    manageImportDialog: {
      isOpen: false,
    },
    customers: [],
    isForAll: true,
  } as {
    isLoading: boolean;
    isEdit: boolean;
    customer: ICustomers;
    date: Date;
    showCallender: boolean;
    searchObj: ISearchUpTime;
    dataCenterOptions: IDropdownOption[];
    dataCenters: IDataCenter[];
    allFloorsDropdownList: IDropdownOption[];
    upTimeList: IUpTime[];
    datesList: string[];
    manageImportDialog: {
      isOpen: boolean;
    };
    isForAll: boolean;
    customers: Array<{
      text: string;
      secondaryText: string;
      id: string;
    }>;
  });
  const [datacenterId, setDatacenterId] = React.useState("" as string);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result && result.success && result.data.length > 0) {
      setState({
        ...state,
        customer: result.data[0],
        isLoading: false,
      });
      searchDataCenters(result.data[0]);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer details",
        "error"
      );
    }
  };

  const searchDataCenters = async (customer: ICustomers) => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCentersOfCustomer(params.customerId);
    if (result && result.success) {
      // let options: IDropdownOption[] = [{ key: "all", text: "All" }];
      let options: IDropdownOption[] = [];
      result.data.forEach((ele) => {
        options.push({ key: ele._id as string, text: ele.name });
      });
      let floorOptions: IDropdownOption[] = [
        // { key: 'all', text: 'All' },
      ];
      /************************* */
      if (options.length > 0) {
        let datacenter = result.data.find(
          (ele) => ele._id === (options[0]?.key as string)
        );

        if (datacenter) {
          const floorByBuilding: {
            [Key: string]: IFloorVM[];
          } = datacenter.floors.reduce((acc: any, d) => {
            if (acc[d.buildingId] == null) {
              acc[d.buildingId] = [];
            }
            let buildingName =
              datacenter?.buildings.find((ele) => ele._id === d.buildingId)
                ?.name || "";
            acc[d.buildingId].push({
              buildingId: d.buildingId,
              buildingName,
              floorId: d._id,
              floorName: d.name,
            });
            return acc;
          }, {});
          let temp = Object.keys(floorByBuilding);
          temp.forEach((d, index) => {
            floorOptions.push({
              key: d,
              text: floorByBuilding[d][0].buildingName,
              itemType: DropdownMenuItemType.Header,
            });
            floorByBuilding[d].forEach((f) => {
              floorOptions.push({
                key: f.floorId,
                text: f.floorName,
                data: { buildingName: f.buildingName },
              });
            });
            if (temp.length != index + 1) {
              floorOptions.push({
                key: "divider_1",
                text: "-",
                itemType: DropdownMenuItemType.Divider,
              });
            }
          });

          // console.log("[floorOptions]", floorOptions);
        }
      }
      /************************* */

      let obj = {
        ...state,
        dataCenterOptions: options,
        dataCenters: result.data,
        customer,
        searchObj: {
          ...state.searchObj,
          datacenterId: (options.length > 0 && options[0].key) || undefined,
          floorId:
            (floorOptions.length > 1 && floorOptions[1].key) || undefined,
        },
        allFloorsDropdownList: floorOptions,
      };
      let searchObj = {
        ...state.searchObj,
        datacenterId: (options.length > 0 && options[0].key) || undefined,
        floorId: (floorOptions.length > 1 && floorOptions[1].key) || undefined,
      };
      getUpTime(obj, searchObj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenters", "error");
    }
  };

  const onSearch = () => {
    if (!state.date) {
      showToast("Please select a date before searching", "error");
    }
    getUpTime();
  };

  const getUpTime = async (obj?: any, searchObj?: any) => {
    setState({ ...state, isLoading: true });
    let tempSearch = { ...state.searchObj };
    if (searchObj) {
      tempSearch = { ...tempSearch, ...searchObj };
    }
    tempSearch.startDate = moment(tempSearch.startDate)
      .startOf("month")
      .format("YYYY-MM-DD");

    tempSearch.endDate = moment(tempSearch.endDate)
      .endOf("month")
      .format("YYYY-MM-DD");
    if (tempSearch.datacenterId === "all") {
      delete tempSearch.datacenterId;
    }
    let date = moment(state.date).format("YYYY-MM");
    let isCurrentMonth =
      state.date.getMonth() + state.date.getFullYear() ===
        new Date().getMonth() + new Date().getFullYear()
        ? true
        : false;
    const arrDays = new Array(
      isCurrentMonth
        ? state.date.getDate()
        : moment(date, "YYYY-MM").daysInMonth()
    )
      .fill(null)
      .map((x, i) =>
        moment(date).startOf("month").add(i, "days").format("DD-MM-YYYY")
      );
    // console.log("dates", arrDays);
    let result = await getUpTimeDetails(tempSearch);
    if (result?.success) {
      let upTimes: IUpTime[] = [];
      if (result.data.length > 0) {
        upTimes = [...result.data];
      } else {
        upTimes = arrDays.map((ele) => {
          return {
            date: moment(ele, "DD-MM-YYYY").toDate(),
            datacenterId: tempSearch.datacenterId as string,
            // customerId: tempSearch.customerId,
            // customerIds: [tempSearch.customerId],
            customerIds: [],
            power: 100,
            crac: 100,
            cctv: 100,
            floorId: tempSearch.floorId as string,
            // customers: [],
            accessControl: 100,
            remarks: "",
            // isForAll: false,
            isForAll: true,
          };
        });
      }
      // console.log("result", result.data);
      setState({
        ...state,
        ...obj,
        upTimeList: upTimes,
        datesList: arrDays,
      });
      setDatacenterId(tempSearch.datacenterId as string);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting up time", "error");
    }
  };

  const onAllChange = (name: string, value: any, values: IUpTime[]) => {
    let upTimeList = [...values];
    upTimeList.map((ele: any) => (ele[name] = value));
    setState({ ...state, upTimeList });
  };

  const onChange = (date: string, name: string, value: any) => {
    let upTimeList = [...state.upTimeList];
    let index: any = upTimeList.findIndex((ele) => {
      let a = moment(
        moment(ele.date).format("DD-MM-YYYY"),
        "DD-MM-YYYY"
      ).toDate();
      let b = moment(moment(date).format("DD-MM-YYYY")).toDate();
      // console.log("1", a);
      // console.log("2", b);
      // console.log("test", a === b);
      if (
        moment(ele.date).format("DD-MM-YYYY") ===
        moment(date).format("DD-MM-YYYY")
      ) {
        return true;
      } else {
        return false;
      }
    });
    let upTimeObj: any = {};
    if (index > -1) {
      upTimeObj = upTimeList[index];
      upTimeObj[name] = value;
      upTimeList[index] = upTimeObj;
    } else {
      upTimeObj = {
        date: moment(date, "DD-MM-YYYY").toDate(),
        customerId: params.customerId,
        datacenterId: state.searchObj.datacenterId as string,
      };
      upTimeObj[name] = value;
      upTimeList.push(upTimeObj);
    }
    setState({ ...state, upTimeList });
  };

  const saveUpTime = async () => {
    // let data = state.upTimeList.map((ele) => {
    //   ele.datacenterId = state.searchObj.datacenterId as string;
    //   ele.customerId = params.customerId;
    //   return ele;
    // });
    let data = [...state.upTimeList];
    let result = await updateUpTime(data);
    if (result?.success) {
      showToast("Up time updated successfully", "success");
    } else {
      showToast(result?.message || "Error while updating up time", "error");
    }
  };

  const onCancel = async () => {
    let obj = { ...state, isEdit: false };
    await getUpTime(obj);
  };
  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>
          {option.data
            ? option.data.buildingName + "-" + option.text
            : option.text}
        </span>
      </div>
    );
  };

  const downloadUptimeReportPdf = async () => {
    let result = await fetch(
      `${API_URL}uptime-report?customerId=${state.searchObj.customerId
      }&startDate=${moment(state.searchObj.startDate)
        .startOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment(state.searchObj.endDate)
          .endOf("month")
          .format("YYYY-MM-DD")}&datacenterId=${state.searchObj.datacenterId
      }&floorId=${state.searchObj.floorId}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    a.download = `${state.customer.name} Monthly Uptime Report.pdf`;
    a.click();
  };

  const handleImportDialogOpen = () => {
    setState({
      ...state,
      manageImportDialog: {
        isOpen: true,
      },
    });
  };

  const handleImportDialogClose = () => {
    setState({
      ...state,
      manageImportDialog: {
        isOpen: false,
      },
    });
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    // suggestionsHeaderText: "Suggested Card holders",
    noResultsFoundText: "No Customer found",
  };

  const onFilterChanged = async (
    filterText: string,
    tagList?: IPersonaProps[]
  ): Promise<IPersonaProps[]> => {
    if (filterText && filterText.length >= 3) {
      let result = await getAllCustomers({
        search: filterText,
        offset: 0,
        limit: 12,
      });
      if (result?.success) {
        const cardHolderTag: IPersonaProps[] = [];
        // let tempcardHoldersList = result.data;

        setState({ ...state });

        result?.data.forEach((item: any) => {
          cardHolderTag.push({
            // key: item._id as string,
            // name: item.firstName + " " + item.lastName,
            // data:  item as IPersonaProps
            text: item.name,
            secondaryText: item.regSapNo,
            id: item._id,
          });
        });
        return cardHolderTag;
      } else {
        return [];
      }
    }
    return [];
  };

  const handleEdit = async () => {
    const tempCustomers: any = [];
    if (state.upTimeList.length > 0) {
      const result = await getCustomers([
        state.searchObj.customerId,
        ...state.upTimeList[0].customerIds,
      ]);
      if (result && result.success) {
        result.data.forEach((d) => {
          tempCustomers.push({
            text: d.name,
            secondaryText: d.regSapNo,
            id: d._id as string,
          });
        });
      }
    }
    setState({
      ...state,
      isEdit: true,
      customers: tempCustomers,
      isForAll: state.upTimeList[0]?.isForAll === true,
    });
  };

  const isPuneDc2 = ["5f0570c337b0eb553b960600"].includes(
    datacenterId as string
  );

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: state.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${state.customer._id}`);
                },
              },
              {
                text: "Up-Time",
                key: "up-time",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Stack
            horizontal
            wrap
            tokens={childrenGap}
            horizontalAlign="space-between"
          >
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal horizontalAlign="start">
                <Stack.Item>
                  {/* <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    value={state.date}
                    showGoToToday={false}
                    showMonthPickerAsOverlay={true}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        date: date as any,
                        searchObj: {
                          ...state.searchObj,
                          startDate: moment(date).startOf("month").toDate(),
                          endDate: moment(date).endOf("month").toDate(),
                        },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                  /> */}
                  <div
                    ref={(calendarBtn) =>
                      (calendarButtonElement = calendarBtn!)
                    }
                  >
                    <DefaultButton
                      text={
                        !state.date
                          ? "Select a month"
                          : moment(state.date).format("MMM-YYYY")
                      }
                      onClick={() =>
                        setState({ ...state, showCallender: true })
                      }
                      className="month-picker-btn"
                    />
                  </div>
                  {state.showCallender && (
                    <Callout
                      isBeakVisible={false}
                      className="ms-DatePicker-callout"
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCallender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={(date: Date | null | undefined) =>
                            setState({
                              ...state,
                              date: date as any,
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .toDate(),
                                endDate: moment(date).endOf("month").toDate(),
                              },
                              showCallender: false,
                            })
                          }
                          onDismiss={() => closeCallender()}
                          isMonthPickerVisible={true}
                          value={state.date}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Datacenter"
                    selectedKey={state.searchObj.datacenterId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.dataCenterOptions}
                    // onChange={(e, v: IDropdownOption | undefined) => {
                    //   if (v) {
                    //     setState({
                    //       ...state,
                    //       searchObj: {
                    //         ...state.searchObj,
                    //         datacenterId: v.key as string,
                    //       },
                    //     });
                    //   }
                    // }}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        let datacenter = state.dataCenters.find(
                          (ele) => ele._id === v.key
                        );
                        let options: IDropdownOption[] = [
                          // { key: 'all', text: 'All' },
                        ];
                        if (datacenter) {
                          const floorByBuilding: {
                            [Key: string]: IFloorVM[];
                          } = datacenter.floors.reduce((acc: any, d) => {
                            if (acc[d.buildingId] == null) {
                              acc[d.buildingId] = [];
                            }
                            let buildingName =
                              datacenter?.buildings.find(
                                (ele) => ele._id === d.buildingId
                              )?.name || "";
                            acc[d.buildingId].push({
                              buildingId: d.buildingId,
                              buildingName,
                              floorId: d._id,
                              floorName: d.name,
                            });
                            return acc;
                          }, {});
                          let temp = Object.keys(floorByBuilding);
                          temp.forEach((d, index) => {
                            options.push({
                              key: d,
                              text: floorByBuilding[d][0].buildingName,
                              itemType: DropdownMenuItemType.Header,
                            });
                            floorByBuilding[d].forEach((f) => {
                              options.push({
                                key: f.floorId,
                                text: f.floorName,
                                data: { buildingName: f.buildingName },
                              });
                            });
                            if (temp.length != index + 1) {
                              options.push({
                                key: "divider_1",
                                text: "-",
                                itemType: DropdownMenuItemType.Divider,
                              });
                            }
                          });

                          // console.log("[options]", options);
                        }
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            datacenterId: v.key as string,
                            floorId:
                              (options.length > 1 &&
                                (options[1].key as string)) ||
                              undefined,
                          },
                          allFloorsDropdownList: options,
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Floor"
                    selectedKey={state.searchObj.floorId}
                    // defaultSelectedKey={state.searchObj.floorId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allFloorsDropdownList}
                    onRenderOption={onRenderOption}
                    onRenderTitle={onRenderTitle}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            floorId: v.key as string,
                            // upsId: '',
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                {!state.isEdit && ![2, 4, 5].includes(tokenData.role) && (
                  <Stack.Item>
                    <DefaultButton
                      disabled={state.isEdit}
                      text="Edit"
                      onClick={() => handleEdit()}
                      className="custom-primary-btn"
                    />
                  </Stack.Item>
                )}
                <Stack.Item>
                  <DefaultButton
                    text="Import"
                    onClick={() => handleImportDialogOpen()}
                    className="custom-primary-btn"
                  />
                </Stack.Item>
                <Stack.Item>
                  <DefaultButton
                    text="Download Report"
                    onClick={() => downloadUptimeReportPdf()}
                    disabled={
                      state.isLoading === true || state.upTimeList.length === 0
                    }
                    className="custom-secondary-btn"
                  />
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
      <br />
      <Stack tokens={childrenGap}>
        {/* {!state.isEdit && (
          <Stack.Item>
            <Stack horizontalAlign="end" horizontal>
              <Stack.Item>
                <DefaultButton
                  disabled={state.isEdit}
                  text="Edit"
                  onClick={() => setState({ ...state, isEdit: true })}
                />
              </Stack.Item>
            </Stack>
          </Stack.Item>
        )} */}
        <Stack.Item>
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={state.upTimeList}
              onSubmit={async (values: IUpTime[], { setSubmitting }) => {
                let data = [...values];
                setState({ ...state, isLoading: true });
                let result = await updateUpTime(
                  data.map((d) => {
                    if (state.isForAll === true) {
                      d.customerIds = [];
                      d.isForAll = state.isForAll;
                    } else {
                      d.customerIds = state.customers.map((c) => c.id);
                      d.isForAll = state.isForAll;
                    }
                    return d;
                  })
                );
                if (result?.success) {
                  setState({
                    ...state,
                    upTimeList: data,
                    isEdit: false,
                    isLoading: false,
                  });
                  showToast("Up Times updated successfully", "success");
                } else {
                  setState({
                    ...state,
                    isEdit: false,
                    isLoading: false,
                  });
                  showToast(
                    result.message || "Error while updating Up Times",
                    "error"
                  );
                }
                setSubmitting(false);
              }}
            >
              {({ handleChange, handleBlur, handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                  <Stack
                    tokens={childrenGap}
                    className={state.isEdit ? "c-stack" : ""}
                  >
                    {state.isEdit && (
                      <Stack.Item>
                        <Stack
                          horizontal
                          horizontalAlign="space-between"
                          wrap
                          tokens={childrenGap}
                        >
                          <Stack.Item>
                            <Stack horizontal wrap tokens={childrenGap}>
                              <Stack.Item>
                                <PrimaryButton type="submit" text="Save" />
                              </Stack.Item>
                              <Stack.Item>
                                <DefaultButton
                                  onClick={() => onCancel()}
                                  text="Cancel"
                                  className="borderless-btn"
                                />
                              </Stack.Item>
                            </Stack>
                          </Stack.Item>
                          <Stack.Item>
                            <Stack
                              tokens={childrenGap}
                              verticalAlign="center"
                              horizontal
                              className="c-itm"
                            // horizontalAlign="end"
                            >
                              {state.isForAll === false && (
                                <Stack.Item>
                                  <NormalPeoplePicker
                                    inputProps={{
                                      placeholder: "Select Customers",
                                    }}
                                    onResolveSuggestions={onFilterChanged}
                                    selectedItems={state.customers}
                                    removeButtonAriaLabel="Remove"
                                    pickerSuggestionsProps={
                                      pickerSuggestionsProps
                                    }
                                    onChange={(items: any) => {
                                      // let selectedItems: any = [];
                                      // items.forEach((element: any) => {
                                      //   selectedItems.push(element.id);
                                      // });
                                      // setFieldValue('customerIds', selectedItems);
                                      // setFieldValue('customers', items);
                                      setState({ ...state, customers: items });
                                      // setState({
                                      //   ...state,
                                      //   // selectedItems,
                                      //   // manageAssignDialog: {
                                      //   //   ...state.manageAssignDialog,
                                      //   // },
                                      // });
                                      // console.log(selectedItems);
                                    }}
                                  />
                                </Stack.Item>
                              )}
                              <Stack.Item>
                                <Checkbox
                                  label="Common for All Customer in Floor"
                                  checked={state.isForAll}
                                  onChange={(e, v) => {
                                    setState({
                                      ...state,
                                      isForAll: v === true,
                                    });
                                  }}
                                />
                              </Stack.Item>
                            </Stack>
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>
                    )}
                    <Stack.Item>
                      <div className="office-table bg-white">
                        <table className="ms-Table bordered-table w-100">
                          <thead className="html-table-thead">
                            <tr style={{ height: 44 }}>
                              <th>
                                <React.Fragment>
                                  <Text>Day Of Month</Text>
                                </React.Fragment>
                              </th>
                              <th>
                                <React.Fragment>
                                  <Text>Power </Text>
                                  {state.isEdit && (
                                    <TextField
                                      suffix="%"
                                      type="number"
                                      min={0}
                                      max={100}
                                      step={"0.01"}
                                      onChange={(event, value) => {
                                        // if(Number(value)>=0&&Number(value)<=100){
                                        onAllChange("power", value, values);
                                        // }
                                      }}
                                    />
                                  )}
                                </React.Fragment>
                              </th>
                              <th>
                                <React.Fragment>
                                  <Text>CRAC/PAC </Text>
                                  {state.isEdit && (
                                    <TextField
                                      suffix="%"
                                      type="number"
                                      min={0}
                                      max={100}
                                      step={"0.01"}
                                      onChange={(event, value) => {
                                        // if(Number(value)>=0&&Number(value)<=100){
                                        onAllChange("crac", value, values);
                                        // }
                                      }}
                                    />
                                  )}
                                </React.Fragment>
                              </th>
                              {!isPuneDc2 && (
                                <th>
                                  <React.Fragment>
                                    <Text>Access Control System </Text>
                                    {state.isEdit && (
                                      <TextField
                                        suffix="%"
                                        type="number"
                                        min={0}
                                        max={100}
                                        step={"0.01"}
                                        onChange={(event, value) => {
                                          // if(Number(value)>=0&&Number(value)<=100){
                                          onAllChange(
                                            "accessControl",
                                            value,
                                            values
                                          );
                                          // }
                                        }}
                                      />
                                    )}
                                  </React.Fragment>
                                </th>
                              )}
                              {!isPuneDc2 && (
                                <th>
                                  <React.Fragment>
                                    <Text>CCTV System </Text>
                                    {state.isEdit && (
                                      <TextField
                                        suffix="%"
                                        type="number"
                                        min={0}
                                        max={100}
                                        step={"0.01"}
                                        onChange={(event, value) => {
                                          // if(Number(value)>=0&&Number(value)<=100){
                                          onAllChange("cctv", value, values);
                                          // }
                                        }}
                                      />
                                    )}
                                  </React.Fragment>
                                </th>
                              )}
                              <th>Remark</th>
                            </tr>
                          </thead>
                          {state.isEdit ? (
                            <tbody>
                              {values.map((item, index) => (
                                <tr key={index}>
                                  <td align="center"> {index + 1} </td>
                                  <td align="center">
                                    <TextField
                                      name={`[${index}].power`}
                                      type="number"
                                      value={String(item.power)}
                                      min={0}
                                      max={100}
                                      step={"0.01"}
                                      suffix="%"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </td>
                                  <td align="center">
                                    <TextField
                                      name={`[${index}].crac`}
                                      type="number"
                                      value={String(item.crac)}
                                      min={0}
                                      max={100}
                                      step={"0.01"}
                                      suffix="%"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </td>
                                  {!isPuneDc2 && (
                                    <td align="center">
                                      <TextField
                                        name={`[${index}].accessControl`}
                                        type="number"
                                        value={String(item.accessControl)}
                                        min={0}
                                        max={100}
                                        step={"0.01"}
                                        suffix="%"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </td>
                                  )}
                                  {!isPuneDc2 && (
                                    <td align="center">
                                      <TextField
                                        name={`[${index}].cctv`}
                                        type="number"
                                        value={String(item.cctv)}
                                        min={0}
                                        max={100}
                                        step={"0.01"}
                                        suffix="%"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </td>
                                  )}
                                  <td align="center">
                                    <TextField
                                      name={`[${index}].remarks`}
                                      value={item.remarks}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody>
                              {state.upTimeList.map((item, index) => (
                                <tr key={index}>
                                  <td align="center"> {index + 1} </td>
                                  <td align="center">
                                    {item?.power !== 0
                                      ? item?.power
                                      : "NA" || ""}
                                  </td>
                                  <td align="center">
                                    {item?.crac !== 0 ? item?.crac : "NA" || ""}
                                  </td>
                                  {!isPuneDc2 && (
                                    <td align="center">
                                      {item?.accessControl !== 0
                                        ? item?.accessControl
                                        : "NA" || ""}
                                    </td>
                                  )}
                                  {!isPuneDc2 && (
                                    <td align="center">
                                      {item?.cctv !== 0
                                        ? item?.cctv
                                        : "NA" || ""}
                                    </td>
                                  )}
                                  <td align="center">{item?.remarks || ""}</td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </Stack.Item>
                    {/* {state.isEdit && (
                      <Stack.Item>
                        <Stack.Item>
                          <Stack
                            horizontal
                            wrap
                            tokens={childrenGap}
                            horizontalAlign="end"
                          >
                            <Stack.Item>
                              <DefaultButton
                                onClick={() => onCancel()}
                                text="Cancel"
                                className="borderless-btn"
                              />
                            </Stack.Item>
                            <Stack.Item>
                              <PrimaryButton type="submit" text="Save" />
                            </Stack.Item>
                          </Stack>
                        </Stack.Item>
                      </Stack.Item>
                    )} */}
                  </Stack>
                </form>
              )}
            </Formik>
          </React.Fragment>
        </Stack.Item>
      </Stack>
      {state.manageImportDialog.isOpen && (
        <ManageImportDialog
          handleImportDialogClose={() => handleImportDialogClose()}
          dataCenterOptions={state.dataCenterOptions}
          datacenterId={state.searchObj.datacenterId}
          date={state.date}
          customer={state.customer}
        />
      )}
    </React.Fragment>
  );
};

export default UpTimeMain;
